/** @jsx jsx */

import { Fragment } from 'react';

import { Radio, RadioGroup } from '@zapier/design-system';
import { Spacing } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import DeveloperFormFields from 'app/developer-v3/components/DeveloperFormFields';
import NonFormaticFieldWrapper from 'app/developer-v3/components/NonFormaticFieldWrapper';
import { setReadOnly } from 'app/developer-v3/utils';

import formFields from '../formFields';

import type { TriggerOperationType } from 'app/developer-v3/platformSchema/trigger';

const Styles = {
  typeWrapper: css`
    display: flex;
  `,
  type: css`
    margin-right: ${Spacing.unit}px;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  label: css`
    margin-left: ${Spacing.extraSmall}px;
  `,
};

type Props = {
  isDisabled?: boolean;
  meta?: {};
  onChange: (name: string, value: Record<string, any>) => void;
  onChangeOperationType: (operationType: TriggerOperationType) => void;
  operationType: TriggerOperationType;
  value: {};
};

function Primary({
  isDisabled,
  meta,
  onChange,
  onChangeOperationType,
  operationType,
  value,
}: Props) {
  return (
    <Fragment>
      <NonFormaticFieldWrapper title="Trigger Type">
        <RadioGroup
          value={operationType}
          onChange={selected =>
            onChangeOperationType(selected as TriggerOperationType)
          }
          name="type"
          isDisabled={isDisabled}
        >
          <div css={Styles.typeWrapper}>
            <label css={Styles.type} htmlFor="hook">
              <Radio id="hook" value="hook" />
              <span css={Styles.label}>REST Hook</span>
            </label>
            <label css={Styles.type} htmlFor="polling">
              <Radio id="polling" value="polling" />
              <span css={Styles.label}>Polling</span>
            </label>
          </div>
        </RadioGroup>
      </NonFormaticFieldWrapper>
      <DeveloperFormFields
        fields={setReadOnly(formFields[operationType] || [], isDisabled)}
        meta={meta}
        onFormChange={(valueNext, name) => onChange(name, valueNext)}
        values={value}
      />
    </Fragment>
  );
}

export default Primary;
